/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {ComponentDefinition, ComponentDefinitionFromJSON, ComponentDefinitionToJSON,} from './ComponentDefinition';

/**
 *
 * @export
 * @interface ComponentDefinitionListApiResult
 */
export interface ComponentDefinitionListApiResult {
    /**
     *
     * @type {boolean}
     * @memberof ComponentDefinitionListApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<ComponentDefinition>}
     * @memberof ComponentDefinitionListApiResult
     */
    content?: Array<ComponentDefinition> | null;
    /**
     *
     * @type {string}
     * @memberof ComponentDefinitionListApiResult
     */
    message?: string | null;
}

export function ComponentDefinitionListApiResultFromJSON(json: any): ComponentDefinitionListApiResult {
    return ComponentDefinitionListApiResultFromJSONTyped(json, false);
}

export function ComponentDefinitionListApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentDefinitionListApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(ComponentDefinitionFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ComponentDefinitionListApiResultToJSON(value?: ComponentDefinitionListApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(ComponentDefinitionToJSON)),
        'message': value.message,
    };
}

